import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { UserService } from "@service/user.service";
import {
  initUserAuthorizations,
  initUserAuthorizationsFailure,
  initUserAuthorizationsSuccess
} from "@store/user-infos/user-infos.action";
import { catchError, of, switchMap } from "rxjs";

@Injectable()
export class UserInfosEffect {
  constructor(public actions$: Actions, public userService: UserService) { }

  initUserAuthorizations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(initUserAuthorizations),
      switchMap((_) =>
        this.userService.getAuthorizations().pipe(
          switchMap((userAuthorizations) => [
            initUserAuthorizationsSuccess({ userAuthorizations }),
          ]),
          catchError((error) =>
            of(initUserAuthorizationsFailure({ error: JSON.stringify(error) }))
          )
        )
      )
    )
  );
}
